module.exports = __webpack_public_path__ + "images/emoji/dart.fbb9a7f4e995f4356e5a.png";